export default __webpack_public_path__ + "static/media/video_thumb.55cb106e.svg";